import { useRef, useState } from "react";
import { Camera, X, CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";
import { uploadPhoto, fileUrl } from "../lib/api";

export default function PhotoPicker({ value = [], onChange, testid = "photo-picker", max = 6 }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, max - value.length);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    try {
      const paths = [];
      for (const f of files) paths.push((await uploadPhoto(f)).path);
      onChange([...value, ...paths]);
    } catch {
      toast.error("Photo upload failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid={testid} className="flex flex-wrap gap-2">
      {value.map((p, i) => (
        <div key={p} className="relative h-20 w-20 rounded-xl overflow-hidden border border-border">
          <img decoding="async" src={fileUrl(p, 160)} alt="" className="h-full w-full object-cover" />
          <button
            type="button"
            data-testid={`${testid}-remove-${i}`}
            onClick={() => onChange(value.filter((x) => x !== p))}
            className="absolute top-1 right-1 h-5 w-5 rounded-full bg-background/90 flex items-center justify-center"
            aria-label="Remove photo"
          >
            <X weight="bold" className="h-3 w-3" />
          </button>
        </div>
      ))}
      {value.length < max && (
        <button
          type="button"
          data-testid={`${testid}-add`}
          onClick={() => ref.current?.click()}
          disabled={busy}
          className="h-20 w-20 rounded-xl border border-dashed border-border flex flex-col items-center justify-center text-muted-foreground hover:text-foreground hover:border-foreground/40 transition-colors"
        >
          {busy ? <CircleNotch className="h-5 w-5 animate-spin" /> : <Camera weight="regular" className="h-5 w-5" />}
          <span className="text-[10px] mt-1">{busy ? "Uploading" : "Add photo"}</span>
        </button>
      )}
      <input
        ref={ref}
        type="file"
        accept="image/jpeg,image/png,image/webp"
        multiple
        className="hidden"
        onChange={handle}
        data-testid={`${testid}-input`}
      />
    </div>
  );
}
